<div class="preview-modal--container" wp-isolated-query-space *ngIf="workPackage">
 <wp-single-card [workPackage]="workPackage"
                 orientation="horizontal"
                 (stateLinkClicked)="openStateLink($event)">
 </wp-single-card>
</div>
